module.exports = __webpack_public_path__ + "static/img/tt3-hd.1b66efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m4/tt3-hd.png
// module id = Uwq3
// module chunks = 1